import Icon from '../../../components/AppIcon';

const QuickActionButton = ({ icon, label, description, onClick, variant = 'default' }) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return 'bg-gradient-to-br from-blue-600 to-blue-700 text-white hover:from-blue-700 hover:to-blue-800 shadow-md hover:shadow-lg';
      case 'accent':
        return 'bg-gradient-to-br from-emerald-600 to-emerald-700 text-white hover:from-emerald-700 hover:to-emerald-800 shadow-md hover:shadow-lg';
      case 'secondary':
        return 'bg-gradient-to-br from-gray-600 to-gray-700 text-white hover:from-gray-700 hover:to-gray-800 shadow-md hover:shadow-lg';
      default:
        return 'bg-white border-2 border-gray-200 hover:border-blue-300 hover:bg-blue-50 text-gray-900 shadow-sm hover:shadow-md';
    }
  };

  return (
    <button
      onClick={onClick}
      className={`${getVariantStyles()} rounded-xl p-6 transition-all duration-200 text-left w-full group active:scale-[0.98]`}
    >
      <div className="flex items-start gap-4">
        <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform group-hover:scale-110 ${
          variant === 'default' ? 'bg-blue-100' : 'bg-white/20'
        }`}>
          <Icon 
            name={icon} 
            size={24} 
            color={variant === 'default' ? '#2563eb' : '#FFFFFF'} 
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold mb-1.5">{label}</h3>
          <p className={`text-sm leading-relaxed ${
            variant === 'default' ? 'text-gray-600' : 'text-white/90'
          }`}>
            {description}
          </p>
        </div>
        <Icon 
          name="ArrowRight" 
          size={20} 
          className={`transition-transform group-hover:translate-x-1 ${
            variant === 'default' ? 'text-gray-400' : 'text-white/70'
          }`} 
        />
      </div>
    </button>
  );
};

export default QuickActionButton;